import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const ProductionServices = ({ section = {} }) => {
  const items = Array.isArray(section.items) ? section.items : [];

  return (
    <Box py={{ xs: 4, md: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="secondary"
        align="center"
      >
        {section.overline || 'Alcance'}
      </Typography>
      <Typography variant="h4" align="center" sx={{ fontWeight: 800, mb: 2 }}>
        {section.title}
      </Typography>
      {section.description && (
        <Typography align="center" color="textSecondary" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
          {section.description}
        </Typography>
      )}

      <Grid container spacing={3}>
        {items.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Box display="flex" alignItems="center" flexWrap="wrap" gap={1} mb={1}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                  {item.badge && <Chip label={item.badge} size="small" color="primary" />}
                  {item.investment && (
                    <Chip label={item.investment} size="small" variant="outlined" color="secondary" />
                  )}
                </Box>
                <Typography variant="body2" color="textSecondary" paragraph>
                  {item.summary}
                </Typography>
                {Array.isArray(item.topics) && item.topics.length > 0 && (
                  <List dense disablePadding>
                    {item.topics.map((topic) => (
                      <ListItem key={topic} disableGutters sx={{ py: 0.25 }}>
                        <ListItemText
                          primary={topic}
                          primaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

ProductionServices.propTypes = {
  section: PropTypes.object,
};

export default ProductionServices;
